import Cookies from 'js-cookie';
import { REFERRAL_COOKIE_NAME } from './util/referralCookie';

export default function getReferralCookie() {
  const value = Cookies.get(REFERRAL_COOKIE_NAME);
  return value ? JSON.parse(value) : undefined;
}
